import PageLoading from 'components/PageLoading';
import styles from './FeedbackLoadingView.module.scss';

function FeedbackLoadingView(): JSX.Element {
  return (
    <div className={styles.container}>
      <PageLoading />
      <p className={styles.message}>Estamos lendo seu texto...</p>
    </div>
  );
}

export default FeedbackLoadingView;
